// @flow
import React from 'react';
import AbstractReactComponent from './../AbstractReactComponent'
import ObjectSuggestField from "./ObjectSuggestField"
import {COMPONENT_CHILDREN} from './../Utils2';

/**
 * ApiObjectSuggestField
 *
 * Field pro API suggest
 *
 * Komunikuje s API a načítá objekty, které renderuje pomocí funkce z props
 * (Včetně debouncingu)
 *
 * Ukázka viz. AdresaField.jsx
 */
class ApiObjectSuggestField extends AbstractReactComponent {

    timer = 0;
    timerPromiseReject = 0;

    static PropTypes = {
        dropdown: React.PropTypes.bool,
        removable: React.PropTypes.bool,
        renderSuggestion: React.PropTypes.func, // render funkce jedné položky, předpis: (i, active, getItemValue, itemValueAttrName) => {}
        filterSuggestions: React.PropTypes.func,
        itemValueAttrName: React.PropTypes.string,  // název atributu v objekt, který je možné použít jako název pro zobrazení uživateli - je možné definovat jen atribut místo celé metody getItemValue, implicitně má hodnotu name
        getItemValue: React.PropTypes.func,
        shouldRenderSuggestions: React.PropTypes.func,
        apiRequestDelay: React.PropTypes.number,
        tags: React.PropTypes.bool, // po zadani hodnoty se vymaže
        addonsBefore: COMPONENT_CHILDREN,
        addonsAfter: COMPONENT_CHILDREN,
        minCharsForFilter: React.PropTypes.number,  // minimální počet znaků, od kterých se bude filtrovat, standardně 0
    };

    static defaultProps = {
        tags: false,
        dropdown: false,
        removable: false,
        renderSuggestion: ObjectSuggestField.defaultProps.renderSuggestion,
        getItemValue: ObjectSuggestField.defaultProps.getItemValue,
        items: [],
        apiRequestDelay: 100,
        shouldRenderSuggestions: ObjectSuggestField.defaultProps.shouldRenderSuggestions,
        minCharsForFilter: ObjectSuggestField.defaultProps.minCharsForFilter,
    };

    handleFilterSuggestions = (value: string, list: Array<any>, getItemValue: Function) => {
        const {filterSuggestions, apiRequestDelay} = this.props;

        if (this.timer) {
            clearTimeout(this.timer);
            this.timer = 0;
        }
        if (this.timerPromiseReject) {
            this.timerPromiseReject();
            this.timerPromiseReject = 0;
        }

        if (apiRequestDelay) {
            this.timerPromise = new Promise((resolve, reject) => {
                this.timerPromiseReject = reject;
                this.timer = setTimeout(() => {
                    filterSuggestions(value)
                        .then(data => resolve(data));
                }, apiRequestDelay);
            });
            return this.timerPromise;
        } else {
            return filterSuggestions(value);
        }
    };

    render() {
        const {getItemValue, renderSuggestion, shouldRenderSuggestions, filterSuggestions, ...other} = this.props;

        return <ObjectSuggestField
            filterSuggestions={this.handleFilterSuggestions}
            getItemValue={getItemValue}
            renderSuggestion={renderSuggestion}
            shouldRenderSuggestions={shouldRenderSuggestions}
            items={[]}
            {...other}
        />
    }
}

export default ApiObjectSuggestField;
